import Box from "@material-ui/core/Box";
import type { TabPanelProps } from "../types/ui";

export const TabPanel = ({
  children,
  hidden,
  index,
  ...other
}: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={hidden}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {!hidden && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
};
